<template>
  <q-page class="dashboard">
    <DashboardMap />
    <div class="dashboard__content">
      <q-card class="dashboard__search">
        <q-card-section :class="!$isDesktop ? 'q-pa-md' : 'q-py-xl q-px-lg'">
          <search-bar :class="{'q-px-sm': $isDesktop}" />
        </q-card-section>
      </q-card>
      <div :class="!$isDesktop ? 'row q-col-gutter-lg q-mt-none' : 'row q-col-gutter-lg q-mt-xl'">
        <div class="col-12 col-md-6">
          <div class="row items-center">
            <span class="text-weight-medium q-mr-sm">Projecten die wachten op toetsing</span>
            <count-chip :count="actionableProjectsCount" />
          </div>
          <q-list
              v-if="hasActionableProjects"
              class="rounded-borders q-mt-md"
              bordered
              separator
          >
            <q-item v-for="project in actionableProjects.data" :key="project.id">
              <q-item-section avatar>
                <status-dot status="pending" class="q-mr-md" />
              </q-item-section>
              <q-item-section>
                <div class="row items-center q-col-gutter-x-md">
                  <div class="col flex items-center">
                    <a
                        :href="$route('project.show', {project_id : project.latest_version.project_id})"
                        class="link link--dark"
                    >
                      {{ project.latest_version.title }}
                    </a>
                  </div>
                  <date-value
                      :value="project.updated_at"
                      class="col-4 text-right"
                      month-string
                  />
                </div>
              </q-item-section>
            </q-item>
            <q-item v-if="actionableProjects.last_page > 1" class="flex flex-center">
              <pagination-links :items="actionableProjects" page-key="actionable" />
            </q-item>
          </q-list>
          <q-card v-else class="q-mt-md">
            <q-card-section>
              Er zijn geen projecten die wachten op toetsing
            </q-card-section>
          </q-card>
        </div>
        <div class="col-12 col-md-6">
          <div class="row items-center">
            <span class="text-weight-medium q-mr-sm">Projecten met notificaties</span>
            <count-chip :count="notifiedProjectsCount" />
          </div>
          <q-list
              v-if="hasNotifiedProjects"
              class="rounded-borders q-mt-md"
              bordered
              separator
          >
            <q-item v-for="project in notifiedProjects.data" :key="project.id">
              <q-item-section avatar>
                <status-dot status="info" class="q-mr-md" />
              </q-item-section>
              <q-item-section>
                <div class="row items-center q-col-gutter-x-md">
                  <div class="col-8">
                    <a
                        :href="$route('project.show', {project_id : project.latest_version.project_id})"
                        class="link link--dark"
                    >
                      {{ project.latest_version.title }}
                    </a>
                  </div>
                  <date-value
                      :value="project.updated_at"
                      class="col-4 text-right"
                      month-string
                  />
                </div>
              </q-item-section>
            </q-item>
            <q-item v-if="notifiedProjects.last_page > 1" class="flex flex-center">
              <pagination-links :items="notifiedProjects" page-key="notified" />
            </q-item>
          </q-list>
          <q-card v-else class="q-mt-md">
            <q-card-section>
              Er zijn geen nieuwe berichten
            </q-card-section>
          </q-card>
        </div>
      </div>
    </div>
  </q-page>
</template>

<script>
import { ruleStatus } from '~HIOR/constants'
import DashboardMap from '~HIOR/components/map/DashboardMap'
import StatusDot from '~HIOR/components/element/StatusDot'

export default {
  components: { DashboardMap, StatusDot },
  props: {
    categories: {
      type: Object,
      default: () => ({}),
    },
    phases: {
      type: Object,
      default: () => ({}),
    },
    startCategories: {
      type: Object,
      default: () => ({}),
    },
    startPhases: {
      type: Object,
      default: () => ({}),
    },
    actionableProjects: {
      type: Object,
      default: () => ({}),
    },
    notifiedProjects: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    ruleStatus
  }),
  computed: {
    hasActionableProjects () {
      return this.actionableProjects.data.length > 0
    },
    actionableProjectsCount () {
      return this.actionableProjects.total
    },
    hasNotifiedProjects () {
      return this.notifiedProjects.data.length > 0
    },
    notifiedProjectsCount () {
      return this.notifiedProjects.total
    },
  },
}
</script>
